<template>
    <div class="user-info">
        <h2 class="user-info__header" v-html="$t('Info.header')"></h2>
        <TotemInput disabled :label="$t('Info.email')" v-model="user.email" fullWidth />
        <TotemInput disabled :label="$t('Info.company')" v-model="user.organization.name" fullWidth v-if="user.organization" />
    </div>
</template>

<script>
    export default {
        props: {
            user: Object,
            currentOrder: Array,
            packages: Array
        }
    }
</script>

<style lang="scss" scoped>
    .user-info {
        display: flex;
        flex-direction: column;
        gap: 24px;
        margin: 0 0 24px;

        &__header {
            font-size: 1.8rem;
            font-family: PlusJakartaSans-Medium, sans-serif;
            margin: 24px 0 0;

            [class*="desktop"] & {
                font-size: 2rem;
                margin: 0;
            }
        }

        &__subtitle {
            font-size: 1.6rem;
            font-family: PlusJakartaSans-Bold, sans-serif;
            margin: 0 0 10px;
        }

        &__data {
            font-size: 1.6rem;
            margin: 0 0 10px;
        }
    }
</style>
